import { OverlayPage } from '@client/components/_core/layout/OverlayPage';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { SupplierDetails } from '@client/components/suppliers/SupplierDetails';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Supplier details',
        },
    },
    params: {
        parse({ supplierId }) {
            return {
                supplierId: BigInt(supplierId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();

    return (
        <OverlayPage
            title="Supplier details"
            size="large"
            afterClose={() => navigate({ moveInMatches: -1 })}
            footer={({ onClose }) => <Button onClick={onClose}>Close</Button>}
        >
            <SupplierDetails id={Route.useParams().supplierId} isReadOnly cardProps={{ type: 'inner' }} />
        </OverlayPage>
    );
}
